/**
 * 顶栏：系统浏览器用 env(safe-area-inset-top)；钱包 WebView 可视起点已在标题栏下，
 * 再叠 safe-area 会空一截，这时把 --app-safe-top 置 0。
 *
 * 底栏：不认钱包 UA，不写死像素。
 * Trust / Safari / Chrome 的底栏是滚下来才滑出、滚上去才收起的，
 * 叠在页面上，100vh / innerHeight 不会跟着变。
 * visualViewport 才是当前看得见的那块；底下被挡住的高度写入 --vv-bottom。
 * 底栏滑出就抬高，收起就回到 0。
 */

const WALLET_UA_MARKERS = [
  'Trust',
  'TrustWallet',
  'MetaMaskMobile',
  'MetaMask',
  'TokenPocket',
  'imToken',
  'imtoken',
  'CoinbaseWallet',
  'CBWallet',
  'Rainbow',
  'BitKeep',
  'Bitget',
  'OKApp',
  'OKX',
  'Phantom',
  'Binance',
  'Safepal',
  'SafePal',
  'MathWallet',
  'Bitpie'
];

let applied = false;
let raf = 0;

function isMobileDevice() {
  const ua = navigator.userAgent || '';
  return /Android|iPhone|iPad|iPod/i.test(ua);
}

export function isTrustWalletBrowser() {
  const ua = navigator.userAgent || '';
  return (
    ua.includes('Trust') ||
    ua.includes('TrustWallet') ||
    typeof window.trustwallet !== 'undefined' ||
    window.ethereum?.isTrust === true
  );
}

export function isInAppWalletBrowser() {
  if (isTrustWalletBrowser()) return true;
  if (!isMobileDevice()) return false;
  const ua = navigator.userAgent || '';
  return WALLET_UA_MARKERS.some((mark) => ua.includes(mark));
}

function readCoveredBottom() {
  const vv = window.visualViewport;
  if (!vv) return 0;

  const fromInner = window.innerHeight - vv.height - vv.offsetTop;
  const fromClient = document.documentElement.clientHeight - vv.height - vv.offsetTop;
  const covered = Math.max(fromInner, fromClient);
  if (!Number.isFinite(covered) || covered < 1) return 0;
  return Math.round(covered);
}

function applyTopInset() {
  const root = document.documentElement;
  const inWallet = isInAppWalletBrowser();

  root.style.setProperty('--wallet-chrome-top', '0px');
  root.style.setProperty(
    '--app-safe-top',
    inWallet ? '0px' : 'env(safe-area-inset-top, 0px)'
  );
}

function applyVisibleBottom() {
  document.documentElement.style.setProperty(
    '--vv-bottom',
    `${readCoveredBottom()}px`
  );
}

function syncInsets() {
  applyTopInset();
  applyVisibleBottom();
}

function scheduleSync() {
  if (raf) return;
  raf = window.requestAnimationFrame(() => {
    raf = 0;
    syncInsets();
  });
}

export function applyBrowserInsets() {
  const root = document.documentElement;

  if (isInAppWalletBrowser()) {
    root.classList.add('in-app-wallet-browser');
  }
  if (isTrustWalletBrowser()) {
    root.classList.add('trust-wallet-browser');
  }

  syncInsets();

  if (applied) return;
  applied = true;

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync);
    window.visualViewport.addEventListener('scroll', scheduleSync);
  }
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', () => {
    window.setTimeout(syncInsets, 300);
  });
  window.addEventListener('pageshow', syncInsets);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') syncInsets();
  });
}
